"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var generator = function generator(name, type) {
  return name ? "@".concat(name, "/").concat(type) : "@region/".concat(type);
};

var _default = function _default(name) {
  return {
    LOAD_START: generator(name, 'LOAD'),
    SET: generator(name, 'SET')
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/region-core/lib/util/getActionTypes.js
// module id = 705
// module chunks = 0